<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                outlined
                v-model="form.password"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                :error-messages="errors.password"
                label="Password *"
                placeholder="Enter password"
                @click:append="show_password = !show_password"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                outlined
                v-model="form.password_confirmation"
                :append-icon="show_password_confirmation ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password_confirmation ? 'text' : 'password'"
                :error-messages="errors.password_confirmation"
                label="Confirm Password *"
                placeholder="Confirm password"
                @click:append="show_password_confirmation = !show_password_confirmation"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.min_deposit_amount"
                outlined
                label="Min Deposit Amount"
                prepend-inner-icon="mdi-cash-plus"
                @keypress="onlyNumbers"
                :error-messages="errors.min_deposit_amount"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.min_withdrawal_amount"
                outlined
                label="Min Withdrawal Amount"
                prepend-inner-icon="mdi-cash-minus"
                @keypress="onlyNumbers"
                :error-messages="errors.min_withdrawal_amount"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save User
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        soft_password: "123456",
        user_devices: [],
        user_locations: [],
        first_name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
        min_deposit_amount: '',
        min_withdrawal_amount: '',
      },
      errors: {},
      companyId: "",
      positionItems: [],
      uplineUserItems: [],
      isDeleteDeviceDialogs: [],
      isDeleteLocationDialogs: [],
      isLoading: false,
      show_password: false,
      show_password_confirmation: false,
      typeItems: [
        { id: "PENDING", text: "PENDING", value: 1 },
        { id: "APPROVED", text: "APPROVED", value: 0 },
      ],
    };
  },
  mounted() {
    this.form.company_id = this.company.id;
    this.form.role_id = "3";
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=user`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        // Basic client-side validation
        if (!this.validateForm()) {
          return;
        }
        
        this.isLoading = true;
        this.clearErrors();
        
        // Prepare form data
        const formData = { ...this.form };
        
        await axios.post("/users", formData);
        
        this.isLoading = false;
        
        // Show success message
        this.$store.dispatch('showSnackbar', {
          message: 'User created successfully!',
          color: 'success'
        });
        
        await this.saveUserTimestamp(null, formData);
        this.$router.push("/users");
        
      } catch (e) {
        this.isLoading = false;
        
        if (e.response && e.response.data && e.response.data.errors) {
          this.errors = e.response.data.errors;
        } else {
          this.$store.dispatch('showSnackbar', {
            message: 'Error creating user. Please try again.',
            color: 'error'
          });
        }
      }
    },
    
    validateForm() {
      const errors = {};
      
      // Required field validation
      if (!this.form.first_name) errors.first_name = ['First name is required'];
      if (!this.form.email) errors.email = ['Email is required'];
      if (!this.form.phone) errors.phone = ['Phone is required'];
      if (!this.form.password) errors.password = ['Password is required'];
      if (!this.form.password_confirmation) errors.password_confirmation = ['Password confirmation is required'];
      
      // Password confirmation validation
      if (this.form.password && this.form.password_confirmation && 
          this.form.password !== this.form.password_confirmation) {
        errors.password_confirmation = ['Password confirmation does not match'];
      }
      
      // Email format validation
      if (this.form.email && !this.isValidEmail(this.form.email)) {
        errors.email = ['Please enter a valid email address'];
      }
      
      // Phone validation
      if (this.form.phone && this.form.phone.length < 10) {
        errors.phone = ['Phone number must be at least 10 digits'];
      }
      
      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    
    clearErrors() {
      this.errors = {};
    },
    
    Add_Empty_Device() {
      let user_device = {
        imei_no: "",
      };
      this.form.user_devices.push(user_device);
    },
    deleteDevice(user_device) {
      this.form.user_devices.splice(
        this.form.user_devices.indexOf(user_device),
        1
      );
      this.isDeleteDeviceDialogs = [];
    },
    Add_Empty_Location() {
      let user_location = {
        imei_no: "",
      };
      this.form.user_locations.push(user_location);
    },
    deleteLocation(user_location) {
      this.form.user_locations.splice(
        this.form.user_locations.indexOf(user_location),
        1
      );
      this.isDeleteLocationDialogs = [];
    },
    UpdateUpline() {
      console.log("Position:" + this.form.position_id);

      let current = this.positionItems.find(
        (position) => position.id == this.form.position_id
      );
      if (
        this.supervisorDownlined.find((position) => position == current.text)
      ) {
        let upline = this.positionItems.find(
          (position) => position.text == "Supervisor"
        );
        if (upline) {
          this.form.upline_position_id = upline ? upline.id : null;
          this.getUplineUsers();
        }
      } else {
        let upline =
          this.positionItems[this.positionItems.indexOf(current) - 1];
        if (upline) {
          this.form.upline_position_id = upline ? upline.id : null;
          this.getUplineUsers();
        }
      }
    },
    async getUplineUsers() {
      this.uplineUserItems = [];
      let query = "position_id=" + this.form.upline_position_id;
      await axios
        .get(`users?${query}`)
        .then((users) => {
          //User
          users.data.data.forEach((user) => {
            this.uplineUserItems.push({
              id: user.id,
              text: user.user_name,
              value: user.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>